import { render, staticRenderFns } from "./main_black.vue?vue&type=template&id=7a4c66ef&scoped=true"
import script from "./main_black.vue?vue&type=script&lang=js"
export * from "./main_black.vue?vue&type=script&lang=js"
import style0 from "./main_black.vue?vue&type=style&index=0&id=7a4c66ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c66ef",
  null
  
)

export default component.exports